import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=348c2df8&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=348c2df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c2df8",
  null
  
)

export default component.exports